import { render, staticRenderFns } from "./link-preference-page-step-preference-card.vue?vue&type=template&id=c6747772"
import script from "./link-preference-page-step-preference-card.vue?vue&type=script&lang=js"
export * from "./link-preference-page-step-preference-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports